import React, { Suspense, useContext, useEffect, useState } from "react";
import Content from "../routes/Content";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import {
  Container,
  Grid,
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  Avatar,
  Tooltip,
  MenuItem,
  TextField,
  Autocomplete,
  Badge,
  Button,
  Paper,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { ThemeContext } from "../Components/context/theme.context";
import { AppContext } from "../Components/context/app.context";
import DashboardLogo from "../Assets/Common/5kRawLogo.svg";
import SearchIcon from "@mui/icons-material/Search";
import AddCar from "../Components/Component/AddCar";
import { FailurePop, SuccessPop } from "../Components/Popup";
import {
  AlertIcon,
  CartIcon,
  HeaderCarIcon,
  NewOfferIcon,
} from "../Components/Styles/Icons";
import LocationAccessPop from "../Components/Component/LocationAccessPop";
import AddAddress from "../Screens/Profile/AddAddress";
import FindBranchPop from "../Components/Component/FindBranchPop";
import DoneIcon from "@mui/icons-material/Done";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import Stack from "@mui/material/Stack";
import LinearProgress from "@mui/material/LinearProgress";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import {
  CurrentBranch,
  CurrentCar,
  CurrentLoc,
  Location,
  LocPermission,
} from "../Components/reducers/config";
import DeleteCart from "../Components/Component/DeleteCart";
import NoNearestPop from "../Components/Component/NoNearestPop";
import BranchCartDeletePop from "../Components/Component/BranchCartDeletePop";
import PersonSharpIcon from "@mui/icons-material/PersonSharp";
import SigninPop from "../Screens/Login/SigninPop";
import UserInfoPop from "../Screens/Login/UserInfoPop";
import { CartContext } from "../Components/context/cartContext";
import SearchPop from "../Components/Component/SearchPop";
import mainBackground from "../Assets/Login/mainBackground.png";

const MainLayout = () => {
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const currentLocation = useLocation();
  const curgeolocation = useSelector((data) => data.loc);
  const ca = useSelector((data) => data.cLoc);
  const currentCar = useSelector((data) => data.car);
  const cBranch = useSelector((data) => data.branch);
  const locPermission = useSelector((data) => data.locPer);

  const signIn = useSelector((data) => data.signinStatus);

  const {
    cartCount,
    fetchCarList,
    CarList,
    userDetail,
    getUserData,
    getUserDataflag,
    setCarValue,
    branchDrop,
    branchValue,
    setBranchValue,
    branchList,
    setNewUser,
    setLocation,
    fetchCartList,
    setCurrentAddress,
    currentAddress,
    cartList,
    openSignin,
    setOpenSignin,
    nearestPop,
    setNearestPop,
  } = useContext(AppContext);

  const { productCount, fetchProductCartList, fetchOfferList, offerList } =
    useContext(CartContext);

  const [openAddCar, setOpenAddCar] = useState(false);
  const [content, setContent] = useState("");
  const [modalSuccess, setModalSuccess] = useState(false);
  const [modalFail, setModalFail] = useState(false);
  const [locationDeniedPop, setLocationDeniedPop] = useState(false);

  const themeBack = localStorage.getItem("5ktheme");
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [anchorElUser1, setAnchorElUser1] = useState(null);
  const [openAddAddress, setOpenAddAddress] = useState(false);
  const [openFindBranch, setOpenFindBranch] = useState(false);
  const [confiAddress, setConfiAddress] = useState(false);
  const [confiBranch, setConfiBranch] = useState(false);
  const [confiCar, setConfiCar] = useState(false);
  const [confiLocation, setConfiLocation] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [detailPop, setDetailPop] = useState(false);
  const [searchPop, setSearchPop] = useState(false);

  //Cart Delete
  const [openDelete, setOpenDelete] = useState(false);
  const [branchCartDelete, setBranchCartDelete] = useState(false);

  //signIn
  // const [openSignin, setOpenSignin] = useState(false);

  const excludedPaths = [
    "/app",
    "/app/",
    "/app/dashboard",
    "/app/profile",
    "/app/servicelist",
    "/app/serviceSubcategory",
    "/app/notifications",
  ];
  const [userLocationEnable, setuserLocationEnable] = useState(locPermission);

  //Functions
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const getDetail = async () => {
    const location =
      ca?.langitude && ca?.latitude
        ? ca
        : global?.$userData?.latitude
        ? {
            langitude: global?.$userData?.langitude,
            latitude: global?.$userData?.latitude,
          }
        : userDetail?.latitude
        ? { langitude: userDetail?.langitude, latitude: userDetail?.latitude }
        : null;

    if (location) {
      await branchList(location?.langitude, location?.latitude);
    } else {
      await getLocation();
    }
  };

  const getLocation = async () => {
    if (navigator.geolocation) {
      navigator.permissions
        .query({ name: "geolocation" })
        .then(async (permissionStatus) => {
          if (permissionStatus.state === "denied") {
            // ca != null && ca != ""
            //   ? await branchList(ca?.langitude, ca?.latitude)
            //   : global?.$userData?.latitude
            //   ? await branchList(
            //       global?.$userData?.langitude,
            //       global?.$userData?.latitude
            //     )
            //   : userDetail?.latitude
            //   ? branchList(userDetail?.langitude, userDetail?.latitude)
            //       :
            setLocationDeniedPop(true);
            setNewUser("new");

            dispatch(LocPermission(false));
          } else {
            dispatch(LocPermission(true));
            console.log("allowed");
            navigator.geolocation.getCurrentPosition(success, error);
            setNewUser("new");
            setLocationDeniedPop(false);
          }
        });
    } else {
      dispatch(LocPermission(false));

      alert("Geolocation is not supported in your browser.");
    }
  };

  function success(position) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    setLocation({ latitude, longitude });

    // ca != null && ca != ""
    //   ? branchList(ca?.langitude, ca?.latitude)
    //   : global?.$userData?.latitude
    //   ? branchList(global?.$userData?.langitude, global?.$userData?.latitude)
    //   : userDetail?.latitude
    //   ? branchList(userDetail?.langitude, userDetail?.latitude)
    //       :
    branchList(longitude, latitude);
    fetchAddress();
  }

  const error = async () => {
    console.log("Unable to retrieve your location");
    // ca != null && ca != ""
    //   ? await branchList(ca?.langitude, ca?.latitude)
    //   : global?.$userData?.latitude
    //   ? branchList(global?.$userData?.langitude, global?.$userData?.latitude)
    //     :
    userDetail?.latitude
      ? branchList(userDetail?.langitude, userDetail?.latitude)
      : setLocationDeniedPop(true);
  };

  const checkNearBranch = () => {
    if (branchDrop?.length == 0 && !cBranch?._id) {
      setNearestPop(true);
    } else {
      setNearestPop(false);
    }
  };

  const addressChange = async () => {
    try {
      Navigate("/app");
      setConfiAddress(false);

      setCurrentAddress(selectedData);
      dispatch(CurrentLoc(selectedData));
      setTimeout(() => {
        branchList(selectedData.langitude, selectedData.latitude);
      }, 500);
    } catch (error) {}
  };

  const fetchAddress = async () => {
    navigator.geolocation.getCurrentPosition(async (position) => {
      const { latitude, longitude } = position.coords;
      const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;
      try {
        const response = await axios.get(url);
        console.log(response.data);
        const tt = response.data;
        setCurrentAddress({
          label: tt.name != "" ? tt.name : tt.address?.village,
          langitude: longitude,
          latitude: latitude,
        });

        dispatch(
          CurrentLoc({
            label: tt.name != "" ? tt.name : tt.address?.village,
            langitude: longitude,
            latitude: latitude,
          })
        );

        dispatch(
          Location({
            label: tt.name != "" ? tt.name : tt.address?.village,
            langitude: longitude,
            latitude: latitude,
          })
        );
        // setcurgeolocation([
        //   {
        //     label: tt.name != "" ? tt.name : tt.address?.village,
        //     langitude: longitude,
        //     latitude: latitude,
        //   },
        // ]);
      } catch (error) {
        // setcurgeolocation([]);
        console.log(error.response);
      }
    });
  };

  const branchChange = async () => {
    try {
      await deleteCart();
      Navigate("/app");
      setConfiBranch(false);
      setBranchValue(selectedData);
      dispatch(CurrentBranch(selectedData));
      fetchCarList();
    } catch (error) {}
  };

  const carChange = async () => {
    await deleteCart();
    Navigate("/app");
    setConfiCar(false);
    dispatch(CurrentCar(selectedData));
    // localStorage.setItem("CurrentCar", JSON.stringify(selectedData));
    setAnchorElUser1(null);
    setCarValue(selectedData);
  };

  const deleteCart = async () => {
    try {
      const response = await global.$axios.get(
        `cart/clear/${global.$userData.id}`
      );
      if (response.data.status === "success") {
        dispatch(CurrentCar(selectedData));
        // localStorage.setItem("CurrentCar", JSON.stringify(selectedData));
        setCarValue(selectedData);
        await fetchCartList();
      } else {
        console.log("Delete Cart Issue", response.data);
      }
    } catch (error) {
      console.log("Delete Cart Issue", error);
    }
  };

  useEffect(() => {
    if (!signIn) return;

    const fetchData = async () => {
      await Promise.all([
        fetchCarList(),
        fetchCartList(),
        fetchProductCartList(),
        getUserData(),
      ]);
    };

    fetchData();
  }, [signIn]);

  useEffect(() => {
    if (getUserDataflag) {
      getDetail();
    }
  }, [getUserDataflag]);

  useEffect(() => {
    if (!signIn) return;

    fetchOfferList();
  }, [branchValue, signIn]);

  // useEffect(() => {
  //   if (signIn) {
  //     checkNearBranch();
  //   }
  // }, [cBranch?._id]);

  useEffect(() => {
    if (global.$userData.user_type === "New") {
      setDetailPop(true);
    }
  }, []);

  return (
    <Grid
      style={{
        backgroundImage:
          "linear-gradient(180deg, rgba(192,222,240,0.2539216370141807) 0%, rgba(255,227,227,0.21750707118785018) 100%)",
        // backgroundImage: `url(${mainBackground})`,

        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        minHeight: "100vh",
      }}
    >
      <AppBar
        position="fixed"
        sx={{
          background: "transparent",
          pt: 2,
          pb: { xs: 3, sm: 0 },
          backdropFilter: "blur(10px)",
        }}
        elevation={0}
      >
        <Container maxWidth="xxl">
          <Toolbar disableGutters>
            <Grid
              container
              sx={{
                display: "flex",
                alignItems: "center",
                ml: { md: 10 },
                flexDirection: { sm: "column", md: "row" },
                background: "transparent",
                mx: 2,
              }}
            >
              <Grid
                item
                container
                md={2}
                sm={12}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Grid
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    height: 25,
                  }}
                >
                  <Tooltip title="Home">
                    <Box
                      component="img"
                      alt="5k Car Care"
                      src={DashboardLogo}
                      sx={{
                        // maxHeight: {
                        //   xs: "40%",
                        //   sm: "20%",
                        //   md: "30%",
                        //   lg: "50%",
                        // },
                        // maxWidth: {
                        //   xs: "40%",
                        //   sm: "20%",
                        //   md: "30%",
                        //   lg: "50%",
                        // },
                        // minHeight: {
                        //   xs: "40%",
                        //   sm: "20%",
                        //   md: "30%",
                        //   lg: "50%",
                        // },
                        // minWidth: {
                        //   xs: "40%",
                        //   sm: "20%",
                        //   md: "30%",
                        //   lg: "50%",
                        // },
                        height: "100px",
                        width: "100px",
                        mb: { xs: 1, sm: 0 },
                        cursor: "pointer",
                      }}
                      onClick={() => Navigate("/app")}
                    />
                  </Tooltip>
                </Grid>
                {/*Only For Mobile */}
                {signIn ? (
                  <Grid
                    sx={{ display: { md: "none", xs: "flex" } }}
                    item
                    sm={7}
                  >
                    <Grid
                      container
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Grid
                        item
                        sx={{
                          gap: 1.5,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Tooltip title="Your Car">
                          <IconButton
                            onClick={(event) => {
                              setAnchorElUser1(event.currentTarget);
                            }}
                            sx={{ p: 0 }}
                          >
                            <HeaderCarIcon />
                          </IconButton>
                        </Tooltip>
                        <Menu
                          sx={{ mt: "45px" }}
                          id="menu-appbar"
                          anchorEl={anchorElUser1}
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          keepMounted
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          open={Boolean(anchorElUser1)}
                          onClose={(event) => setAnchorElUser1(null)}
                        >
                          {CarList?.map((item, index) => {
                            return (
                              <MenuItem
                                key={`${index}${new Date()}`}
                                onClick={(event) => {
                                  if (
                                    !excludedPaths.includes(
                                      currentLocation.pathname
                                    )
                                  ) {
                                    setSelectedData(item);
                                    setConfiCar(true);
                                  } else {
                                    if (
                                      cartList &&
                                      cartList?.length > 0 &&
                                      currentCar?._id !== item?._id
                                    ) {
                                      setSelectedData(item);
                                      setOpenDelete(true);
                                    } else {
                                      dispatch(CurrentCar(item));

                                      setCarValue(item);
                                    }
                                    setAnchorElUser1(null);
                                  }
                                }}
                              >
                                <Typography
                                  sx={{
                                    color:
                                      currentCar?.reg_number == item?.reg_number
                                        ? "#071BC7"
                                        : "",
                                  }}
                                >
                                  {item?.reg_number}
                                </Typography>
                                {currentCar?.reg_number == item?.reg_number && (
                                  <DoneIcon
                                    width={20}
                                    height={20}
                                    sx={{ pl: 1, color: "#071BC7", pb: 1 }}
                                  />
                                )}
                              </MenuItem>
                            );
                          })}
                          <MenuItem>
                            <Button
                              sx={{ textTransform: "capitalize" }}
                              onClick={() => {
                                setAnchorElUser1(null);
                                setOpenAddCar(true);
                              }}
                            >
                              Add New Car
                            </Button>
                          </MenuItem>
                        </Menu>
                        <Tooltip title="Offers">
                          <IconButton
                            sx={{ p: 0 }}
                            onClick={() => {
                              Navigate("/app/offers");
                            }}
                          >
                            {Object.keys(offerList)?.length > 0 ? (
                              <Badge
                                color="secondary"
                                badgeContent=" "
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "right",
                                }}
                                variant="dot"
                                className="animate__animated  animate__tada animate__infinite infinite animate__slow"
                              >
                                <NewOfferIcon />
                              </Badge>
                            ) : (
                              <NewOfferIcon />
                            )}
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="View Cart">
                          <IconButton
                            sx={{ p: 0 }}
                            onClick={() => Navigate("/app/cart")}
                          >
                            <Badge
                              color="secondary"
                              badgeContent={cartCount + productCount}
                            >
                              <CartIcon />
                            </Badge>
                          </IconButton>
                        </Tooltip>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <Tooltip title="Profile">
                            <IconButton
                              onClick={() => Navigate("/app/Profile")}
                              sx={{ p: 0 }}
                            >
                              <Avatar
                                variant="rounded"
                                sx={{ borderRadius: 2 }}
                                alt={userDetail?.name}
                                src={
                                  userDetail?.profile_image
                                    ? userDetail?.profile_image
                                    : userDetail?.name
                                }
                              />
                            </IconButton>
                          </Tooltip>
                          <Menu
                            sx={{ mt: "45px" }}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}
                            keepMounted
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                          >
                            <MenuItem
                              onClick={() => {
                                Navigate("/app/profile");
                                handleCloseUserMenu();
                              }}
                            >
                              <Typography
                                sx={{ cursor: "pointer" }}
                                onClick={() => Navigate("/app/profile")}
                                textAlign="center"
                              >
                                Profile
                              </Typography>
                            </MenuItem>
                          </Menu>
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid sx={{ display: { md: "none", xs: "flex" } }}>
                    <Grid
                      item
                      sx={{
                        gap: 1.5,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        size="medium"
                        variant="outlined"
                        sx={{
                          textTransform: "none",
                          color: "#071CB7",
                        }}
                        onClick={() => setOpenSignin(true)}
                      >
                        <PersonSharpIcon sx={{ pr: 1, color: "#071CB7" }} />{" "}
                        Sign In
                      </Button>
                    </Grid>
                  </Grid>
                )}
                {/*Only For Mobile */}
              </Grid>

              <Grid
                container
                item
                sm={7}
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Grid item xs={12} md={3.8} sx={{ p: 1 }}>
                  <Autocomplete
                    value={currentAddress}
                    onChange={(event, newValue) => {
                      if (!excludedPaths.includes(currentLocation.pathname)) {
                        setSelectedData(newValue);
                        setConfiAddress(true);
                      } else {
                        branchList(newValue.langitude, newValue.latitude);
                        setCurrentAddress(newValue);
                        dispatch(CurrentLoc(newValue));
                        // localStorage.setItem(
                        //   "UserLocation",
                        //   JSON.stringify(newValue)
                        // );
                        // dispatch(
                        //   CurrentBranch(branchDrop?.length > 0 && branchDrop[0])
                        // );
                        // localStorage.setItem(
                        //   "CurrentBranch",
                        //   JSON.stringify(
                        //     branchDrop?.length > 0 && branchDrop[0]
                        //   )
                        // );
                        // setBranchValue(branchDrop?.length > 0 && branchDrop[0]);
                      }
                    }}
                    noOptionsText={"No Saved Address"}
                    options={(userDetail?.address_details ?? []).concat(
                      Object.values(curgeolocation).length > 0
                        ? [{ ...curgeolocation }]
                        : []
                    )}
                    size="small"
                    disableClearable
                    autoComplete
                    fullWidth
                    getOptionLabel={(option) => option.label || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.label == value.label
                    }
                    // sx={{ width: "48%" }}
                    renderInput={(params) => (
                      <TextField
                        label="Your Location"
                        variant="outlined"
                        {...params}
                        sx={{
                          ".css-12yjm75-MuiInputBase-input-MuiOutlinedInput-input":
                            { fontSize: 14 },
                        }}
                        InputProps={{
                          ...params.InputProps,
                          readOnly: true,
                          // startAdornment: (
                          //   <InputAdornment position="start">
                          //     <FmdGoodOutlinedIcon />
                          //   </InputAdornment>
                          // ),
                        }}
                      />
                    )}
                    PaperComponent={({ children }) => {
                      return (
                        <Paper>
                          {children}
                          <Button
                            color="primary"
                            fullWidth
                            sx={{
                              justifyContent: "center",
                              textTransform: "capitalize",
                              gap: 1,
                            }}
                            disabled={!userLocationEnable}
                            onMouseDown={() => {
                              if (
                                !excludedPaths.includes(
                                  currentLocation.pathname
                                )
                              ) {
                                setConfiLocation(true);
                              } else {
                                fetchAddress();
                              }
                            }}
                          >
                            <MyLocationIcon fontSize="small" />{" "}
                            {userLocationEnable
                              ? "Use Current Location"
                              : "Location Denied"}
                          </Button>

                          <Button
                            color="primary"
                            fullWidth
                            sx={{
                              justifyContent: "center",
                              textTransform: "capitalize",
                            }}
                            onMouseDown={() => {
                              if (global.$signInStatus) {
                                setOpenAddAddress(true);
                              } else {
                                setOpenSignin(true);
                              }
                            }}
                          >
                            + Add New
                          </Button>
                        </Paper>
                      );
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={3.8} sx={{ p: 1 }}>
                  <Autocomplete
                    value={branchValue}
                    onChange={(event, newValue) => {
                      if (!excludedPaths.includes(currentLocation.pathname)) {
                        setSelectedData(newValue);
                        setConfiBranch(true);
                      } else if (cartList && cartList?.length > 0) {
                        setSelectedData(newValue);
                        setBranchCartDelete(true);
                      } else {
                        setBranchValue(newValue);
                        dispatch(CurrentBranch(newValue));
                      }
                    }}
                    noOptionsText={"No Nearby Branches"}
                    options={branchDrop}
                    size="small"
                    disableClearable
                    autoComplete
                    fullWidth
                    getOptionLabel={(option) => option.name || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.name == value.name
                    }
                    // sx={{ width: "48%" }}
                    renderInput={(params) => (
                      <TextField
                        label="Branch"
                        variant="outlined"
                        {...params}
                        sx={{
                          ".css-12yjm75-MuiInputBase-input-MuiOutlinedInput-input":
                            { fontSize: 14 },
                        }}
                        InputProps={{
                          ...params.InputProps,
                          // startAdornment: (
                          //   <InputAdornment position="start">
                          //     <BranchIcon width={20} height={20} />
                          //   </InputAdornment>
                          // ),
                        }}
                      />
                    )}
                    PaperComponent={({ children }) => {
                      return (
                        <Paper>
                          {children}
                          <Button
                            color="primary"
                            fullWidth
                            sx={{
                              justifyContent: "center",
                              textTransform: "capitalize",
                              color: "#071CB7",
                            }}
                            onMouseDown={() => {
                              setOpenFindBranch(true);
                            }}
                          >
                            Choose Other Branch
                          </Button>
                        </Paper>
                      );
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={3.8} sx={{ p: 1 }}>
                  {/* <Autocomplete
                    value={searchValue}
                    onChange={(e, val) => {
                      // setSearchValue(val);
                      Navigate("/app/booking", { state: { data: val } });
                    }}
                    noOptionsText={"No Recent Searches"}
                    disableClearable
                    autoComplete
                    size="small"
                    options={searchDrop}
                    getOptionLabel={(option) => option.name || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.name == value.name
                    }
                    sx={{
                      ".css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root": {
                        borderRadius: 1,
                        fontSize: 14,
                      },
                      width: { xs: "100%" },
                    }}
                    // InputProps={{
                    //   startAdornment: (
                    //     <InputAdornment position="start">
                    //       <Search fontSize="small" />
                    //     </InputAdornment>
                    //   ),
                    // }}
                    renderInput={(params) => (
                      <TextField
                        sx={{
                          ".css-16slxrv-MuiInputBase-input-MuiOutlinedInput-input":
                            { fontSize: 14 },
                        }}
                        placeholder="Search Service"
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          type: "search",
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search fontSize="small" />
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                  /> */}

                  <Grid
                    sx={{
                      display: "flex",
                      gap: 1,
                      alignItems: "center",
                      border: "1px solid rgb(0,0,0,0.3)",
                      p: 1,
                      borderRadius: 1,
                    }}
                    onClick={() => setSearchPop(true)}
                  >
                    <SearchIcon sx={{ color: "#232323" }} />
                    <Typography sx={{ color: "#232323" }}>Search</Typography>
                  </Grid>

                  {/* <TextField
                    sx={{
                      ".css-16slxrv-MuiInputBase-input-MuiOutlinedInput-input":
                        { fontSize: 14 },
                    }}
                    size="small"
                    placeholder="Search Service"
                    InputProps={{
                      type: "search",
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search fontSize="small" />
                        </InputAdornment>
                      ),
                    }}
                    onClick={() => setSearchPop(true)}
                  /> */}
                </Grid>
              </Grid>

              <Grid
                container
                item
                sm={2.5}
                xs={12}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                {/*For Web */}
                {signIn ? (
                  <Grid sx={{ display: { md: "flex", xs: "none" } }}>
                    <Grid
                      item
                      xs={12}
                      sx={{
                        gap: 1.5,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: { xs: "center", md: "flex-end" },
                      }}
                    >
                      <Tooltip title="Your Car">
                        <IconButton
                          onClick={(event) =>
                            setAnchorElUser1(event.currentTarget)
                          }
                          sx={{ p: 0 }}
                        >
                          <HeaderCarIcon />
                        </IconButton>
                      </Tooltip>
                      <Menu
                        sx={{ mt: "45px" }}
                        id="menu-appbar"
                        anchorEl={anchorElUser1}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        keepMounted
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        open={Boolean(anchorElUser1)}
                        onClose={(event) => setAnchorElUser1(null)}
                      >
                        {CarList?.map((item, index) => {
                          return (
                            <MenuItem
                              key={`${index}${new Date()}`}
                              onClick={(event) => {
                                if (
                                  !excludedPaths.includes(
                                    currentLocation.pathname
                                  )
                                ) {
                                  setConfiCar(true);
                                  setSelectedData(item);
                                } else {
                                  if (
                                    cartList &&
                                    cartList?.length > 0 &&
                                    currentCar?._id !== item?._id
                                  ) {
                                    setSelectedData(item);
                                    setOpenDelete(true);
                                  } else {
                                    dispatch(CurrentCar(item));
                                    setCarValue(item);
                                  }
                                  setAnchorElUser1(null);
                                }
                              }}
                            >
                              <Typography
                                sx={{
                                  color:
                                    currentCar?.reg_number == item?.reg_number
                                      ? "#071BC7"
                                      : "",
                                }}
                              >
                                {item?.reg_number}
                              </Typography>
                              {currentCar?.reg_number == item?.reg_number && (
                                <DoneIcon
                                  width={20}
                                  height={20}
                                  sx={{ pl: 1, color: "#071BC7", pb: 1 }}
                                />
                              )}
                            </MenuItem>
                          );
                        })}
                        <MenuItem>
                          <Button
                            sx={{ textTransform: "capitalize" }}
                            onClick={() => {
                              setAnchorElUser1(null);
                              setOpenAddCar(true);
                            }}
                          >
                            Add New Car
                          </Button>
                        </MenuItem>
                      </Menu>
                      <Tooltip title="Offers">
                        <IconButton
                          sx={{ p: 0 }}
                          onClick={() => {
                            Navigate("/app/offers");
                          }}
                        >
                          {Object.keys(offerList)?.length > 0 ? (
                            <Badge
                              color="secondary"
                              badgeContent=" "
                              anchorOrigin={{
                                vertical: "top",
                                horizontal: "right",
                              }}
                              variant="dot"
                              className="animate__animated  animate__tada animate__infinite infinite animate__slow"
                            >
                              <NewOfferIcon />
                            </Badge>
                          ) : (
                            <NewOfferIcon />
                          )}
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="View Cart">
                        <IconButton
                          sx={{ p: 0 }}
                          onClick={() => Navigate("/app/cart")}
                        >
                          <Badge
                            color="secondary"
                            badgeContent={cartCount + productCount}
                          >
                            <CartIcon />
                          </Badge>
                        </IconButton>
                      </Tooltip>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Tooltip title="Profile">
                          <IconButton
                            onClick={() => Navigate("/app/profile")}
                            sx={{ p: 0 }}
                          >
                            <Avatar
                              variant="rounded"
                              sx={{ borderRadius: 2 }}
                              alt={userDetail?.name}
                              src={
                                userDetail?.profile_image
                                  ? userDetail?.profile_image
                                  : userDetail?.name
                              }
                            />
                          </IconButton>
                        </Tooltip>
                        <Menu
                          sx={{ mt: "45px" }}
                          id="menu-appbar"
                          anchorEl={anchorElUser}
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          keepMounted
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          open={Boolean(anchorElUser)}
                          onClose={handleCloseUserMenu}
                        >
                          <MenuItem
                            onClick={() => {
                              Navigate("/app/Profile");
                              handleCloseUserMenu();
                            }}
                          >
                            <Typography
                              sx={{ cursor: "pointer" }}
                              onClick={() => Navigate("/app/profile")}
                              textAlign="center"
                            >
                              Profile
                            </Typography>
                          </MenuItem>
                        </Menu>
                      </Box>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid sx={{ display: { md: "flex", xs: "none" } }}>
                    <Button
                      size="medium"
                      variant="outlined"
                      sx={{
                        textTransform: "none",
                        color: "#071CB7",
                        border: "1px solid #071CB7",
                      }}
                      onClick={() => setOpenSignin(true)}
                    >
                      <PersonSharpIcon sx={{ pr: 1, color: "#071CB7" }} /> Sign
                      In
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Toolbar>
        </Container>
        {/* <Stack sx={{ width: "100%", color: "grey.500" }} spacing={1}>
          <LinearProgress sx={{ color: "#071CB7" }} />
        </Stack> */}
      </AppBar>
      <Box sx={{ height: "100%" }}>
        <Toolbar />
        <Content>
          <Suspense
            fallback={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: "30px 0px",
                }}
              >
                <Stack sx={{ width: "100%", color: "grey.500" }} spacing={1}>
                  <LinearProgress sx={{ color: "#071CB7" }} />
                </Stack>
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </Content>
      </Box>
      {openAddCar && (
        <AddCar openAddCar={openAddCar} setOpenAddCar={setOpenAddCar} />
      )}
      {modalSuccess && (
        <SuccessPop
          modalSuccess={modalSuccess}
          setModalSuccess={setModalSuccess}
          content={content}
        />
      )}
      {modalFail && (
        <FailurePop
          modalFail={modalFail}
          setModalFail={setModalFail}
          content={content}
        />
      )}
      {locationDeniedPop && (
        <LocationAccessPop
          locationDeniedPop={locationDeniedPop}
          setLocationDeniedPop={setLocationDeniedPop}
        />
      )}
      {openAddAddress && (
        <AddAddress
          openAddAddress={openAddAddress}
          setOpenAddAddress={setOpenAddAddress}
          getUserData={getUserData}
        />
      )}

      {openDelete && (
        <DeleteCart
          openDelete={openDelete}
          setOpenDelete={setOpenDelete}
          selectedCar={selectedData}
        />
      )}

      {branchCartDelete && (
        <BranchCartDeletePop
          branchCartDelete={branchCartDelete}
          setBranchCartDelete={setBranchCartDelete}
          selectedBranch={selectedData}
          setOpenFindBranch={false}
        />
      )}

      {confiAddress && (
        <Dialog
          open={confiAddress}
          onClose={() => setConfiAddress(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <Grid sx={{ justifyContent: "center", display: "flex" }}>
            <AlertIcon width={200} height={200} />
          </Grid>
          <DialogContent sx={{ width: "80%", alignSelf: "center" }}>
            <DialogContentText
              id="alert-dialog-description"
              sx={{ textAlign: "center", color: "#232323", fontWeight: 550 }}
            >
              Changes will take you to Dashboard.Sure you want to make changes?
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ px: 5, justifyContent: "space-around", mb: 1 }}>
            <Button
              onClick={() => setConfiAddress(false)}
              sx={{ textTransform: "capitalize", minWidth: 100, maxWidth: 120 }}
              variant="contained"
            >
              Cancel
            </Button>
            <Button
              onClick={addressChange}
              autoFocus
              sx={{ textTransform: "capitalize", minWidth: 100, maxWidth: 120 }}
              variant="outlined"
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {confiLocation && (
        <Dialog
          open={confiLocation}
          onClose={() => setConfiLocation(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <Grid sx={{ my: 5 }}>
            <Grid sx={{ justifyContent: "center", display: "flex" }}>
              <AlertIcon />
            </Grid>
            <DialogContent sx={{ width: "80%", ml: { md: 3 } }}>
              <DialogContentText
                id="alert-dialog-description"
                sx={{ textAlign: "center", color: "#232323", fontWeight: 550 }}
              >
                Changes will take you to Dashboard.Sure you want to make
                changes?
              </DialogContentText>
            </DialogContent>
            <DialogActions
              sx={{ px: 5, justifyContent: "space-around", mb: 1 }}
            >
              <Button
                onClick={() => setConfiLocation(false)}
                sx={{
                  textTransform: "capitalize",
                  minWidth: 100,
                  maxWidth: 120,
                }}
                variant="contained"
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  Navigate("/app");
                  fetchAddress();
                  setConfiLocation(false);
                }}
                autoFocus
                sx={{
                  textTransform: "capitalize",
                  minWidth: 100,
                  maxWidth: 120,
                }}
                variant="outlined"
              >
                Yes
              </Button>
            </DialogActions>
          </Grid>
        </Dialog>
      )}

      {confiBranch && (
        <Dialog
          open={confiBranch}
          onClose={() => setConfiBranch(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <Grid sx={{ my: 5 }}>
            <Grid sx={{ justifyContent: "center", display: "flex" }}>
              <AlertIcon />
            </Grid>
            <DialogContent
              sx={{
                width: "80%",
                ml: { md: 3 },
              }}
            >
              <DialogContentText
                id="alert-dialog-description"
                sx={{
                  textAlign: "center",
                  color: "#232323",
                  fontWeight: 550,
                }}
              >
                Changes will take you to Dashboard & your items in cart will be
                removed.Sure you want to make changes?
              </DialogContentText>
            </DialogContent>
            <DialogActions
              sx={{ px: 5, justifyContent: "space-around", mb: 1 }}
            >
              <Button
                onClick={() => setConfiBranch(false)}
                sx={{
                  textTransform: "capitalize",
                  minWidth: 100,
                  maxWidth: 120,
                }}
                variant="contained"
              >
                Cancel
              </Button>
              <Button
                onClick={branchChange}
                autoFocus
                sx={{
                  textTransform: "capitalize",
                  minWidth: 100,
                  maxWidth: 120,
                }}
                variant="outlined"
              >
                Yes
              </Button>
            </DialogActions>
          </Grid>
        </Dialog>
      )}

      {confiCar && (
        <Dialog
          open={confiCar}
          onClose={() => setConfiCar(false)}
          maxWidth={"sm"}
        >
          <Grid sx={{ my: 5 }}>
            <Grid sx={{ justifyContent: "center", display: "flex" }}>
              <AlertIcon />
            </Grid>
            <DialogContent sx={{ width: "80%", ml: { md: 3 } }}>
              <DialogContentText
                id="alert-dialog-description"
                sx={{ textAlign: "center", color: "#232323", fontWeight: 550 }}
              >
                Changes will take you to Dashboard & your items in cart will be
                removed.Sure you want to make changes?
              </DialogContentText>
            </DialogContent>

            <DialogActions
              sx={{ px: 5, justifyContent: "space-around", mb: 1 }}
            >
              <Button
                onClick={() => setConfiCar(false)}
                sx={{
                  textTransform: "capitalize",
                  minWidth: 100,
                  maxWidth: 120,
                }}
                variant="contained"
              >
                Cancel
              </Button>
              <Button
                onClick={carChange}
                autoFocus
                sx={{
                  textTransform: "capitalize",
                  minWidth: 100,
                  maxWidth: 120,
                }}
                variant="outlined"
              >
                Yes
              </Button>
            </DialogActions>
          </Grid>
        </Dialog>
      )}

      {openFindBranch && (
        <FindBranchPop
          openFindBranch={openFindBranch}
          setOpenFindBranch={setOpenFindBranch}
          setNearestPop={setNearestPop}
        />
      )}

      {nearestPop && (
        <NoNearestPop nearestPop={nearestPop} setNearestPop={setNearestPop} />
      )}

      {openSignin && (
        <SigninPop openSignin={openSignin} setOpenSignin={setOpenSignin} />
      )}

      {detailPop && (
        <UserInfoPop
          detailPop={detailPop}
          setDetailPop={setDetailPop}
          setOpenSignin={setOpenSignin}
        />
      )}

      {searchPop && (
        <SearchPop searchPop={searchPop} setSearchPop={setSearchPop} />
      )}
    </Grid>
  );
};

export default MainLayout;
